import { ForwardedRef, forwardRef, ReactNode } from 'react';
import { coreTokens } from '../../core';
import { Flex } from '../layout';

export interface ButtonArrangeProps {
	gap?: string;
	justify?: 'space-between' | 'center' | 'flex-end';
	children: ReactNode;
}

function _ButtonArrange({ gap, justify, children }: ButtonArrangeProps, ref: ForwardedRef<HTMLDivElement>): JSX.Element {
	return (
		<Flex
			gap={gap ?? coreTokens.spacing.x2}
			breakpointSmallAndUp={{
				direction: 'row',
				justify: justify ?? 'flex-end',
			}}
			ref={ref}
		>
			{children}
		</Flex>
	);
}

export const ButtonArrange = forwardRef(_ButtonArrange);
